<div class="auth-page">
  <mat-card class="auth-card">
    <header class="card-header">
      <div class="brand">
        <img
          class="brand-icon"
          src="https://firebasestorage.googleapis.com/v0/b/trump-post-alert-prod.firebasestorage.app/o/images%2Flogo%2FLogo-w200.png?alt=media&token=e5cda080-3231-479b-92ab-2466531af49c"
          alt="Trump Post Alert" />
        <div>
          <h1>{{ t("header.title") }}</h1>
          <p class="subtitle">
            {{ t(isCreatingAccount() ? "header.subtitle.signUp" : "header.subtitle.signIn") }}
          </p>
        </div>
      </div>
    </header>

    <section class="card-content">
      @if (!accountSetupVisible()) {
        @if (errorMessage()) {
          <div class="error-banner">{{ errorMessage() }}</div>
        }

        @if (providerToggles().emailPassword) {
          <form class="auth-form" [formGroup]="form" (ngSubmit)="onSubmitEmailPassword()" novalidate>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ t("form.email.label") }}</mat-label>
              <input matInput type="email" formControlName="email" autocomplete="email" />
              <mat-icon matSuffix>mail</mat-icon>
              @if (form.controls.email.hasError("required")) {
                <mat-error>{{ t("form.email.errors.required") }}</mat-error>
              }
              @if (form.controls.email.hasError("email")) {
                <mat-error>{{ t("form.email.errors.email") }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ t("form.password.label") }}</mat-label>
              <input
                matInput
                type="password"
                formControlName="password"
                [attr.autocomplete]="isCreatingAccount() ? 'new-password' : 'current-password'" />
              <mat-icon matSuffix>lock</mat-icon>
              @if (form.controls.password.hasError("required")) {
                <mat-error>{{ t("form.password.errors.required") }}</mat-error>
              }
              @if (form.controls.password.hasError("minlength")) {
                <mat-error>{{ t("form.password.errors.minLength") }}</mat-error>
              }
            </mat-form-field>

            @if (isCreatingAccount()) {
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ t("form.confirmPassword.label") }}</mat-label>
                <input matInput type="password" formControlName="confirmPassword" autocomplete="new-password" />
                <mat-icon matSuffix>lock</mat-icon>
                @if (form.controls.confirmPassword.hasError("required")) {
                  <mat-error>
                    {{ t("form.confirmPassword.errors.required") }}
                  </mat-error>
                }
                @if (form.controls.confirmPassword.hasError("mismatch")) {
                  <mat-error>
                    {{ t("form.confirmPassword.errors.mismatch") }}
                  </mat-error>
                }
              </mat-form-field>
            }

            <button mat-raised-button color="primary" type="submit" class="submit-button" [disabled]="submitInFlight()">
              @if (submitInFlight()) {
                <mat-progress-spinner diameter="18" mode="indeterminate" class="button-spinner"></mat-progress-spinner>
              }
              <span>{{ t(submitButtonTranslationKey()) }}</span>
            </button>
          </form>
        }

        @if (providerToggles().emailPassword) {
          <div class="mode-toggle">
            <span>{{ t(modeSwitchPrefixTranslationKey()) }}</span>
            <button mat-button type="button" class="mode-toggle-button" (click)="toggleAccountCreation()" [disabled]="submitInFlight()">
              {{ t(modeSwitchLabelTranslationKey()) }}
            </button>
          </div>
        }

        @if (providerToggles().emailPassword && showThirdPartyProviders()) {
          <div class="divider">
            <mat-divider></mat-divider>
            <span>{{ t(providerSectionTranslationKey()) }}</span>
            <mat-divider></mat-divider>
          </div>
        }

        @if (showThirdPartyProviders()) {
          <div class="social-buttons">
            @if (providerToggles().google) {
              <button
                mat-stroked-button
                type="button"
                class="social-button google"
                (click)="signInWithGoogle()"
                [disabled]="submitInFlight()">
                <mat-icon>g_translate</mat-icon>
                <span>{{ t("providers.google") }}</span>
              </button>
            }
            @if (providerToggles().facebook) {
              <button
                mat-stroked-button
                type="button"
                class="social-button facebook"
                (click)="signInWithFacebook()"
                [disabled]="submitInFlight()">
                <mat-icon>facebook</mat-icon>
                <span>{{ t("providers.facebook") }}</span>
              </button>
            }
            @if (providerToggles().apple) {
              <button
                mat-stroked-button
                type="button"
                class="social-button apple"
                (click)="signInWithApple()"
                [disabled]="submitInFlight()">
                <mat-icon>apple</mat-icon>
                <span>{{ t("providers.apple") }}</span>
              </button>
            }
          </div>
        }
      } @else {
        @if (pendingIdToken(); as token) {
          <app-account-setup
            [idToken]="token"
            [languageOptions]="availableLanguages"
            [translate]="translateFn"
            [mode]="accountSetupMode()"
            [defaults]="accountSetupDefaults()"
            (completed)="onAccountSetupCompleted($event)"></app-account-setup>
        } @else {
          <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        }
      }
    </section>

    <footer class="card-footer">
      <p>
        {{ t("footer.agreementPrefix") }}
        <a [href]="termsOfUseUrl" target="_blank" rel="noopener noreferrer">
          {{ t("footer.termsLink") }}
        </a>
        {{ t("footer.connector") }}
        <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">
          {{ t("footer.privacyLink") }}
        </a>
        {{ t("footer.suffix") }}
      </p>
    </footer>
  </mat-card>
</div>
